export default {
    methods: {
        // 对比视图下左右id一样时 需要同步状态
        // 对比视图下左右id一样时 需要同步状态
        // 对比视图下左右id一样时 需要同步状态
        syncSavedFolderIdInCompare({ patentId, value }) {
            if ((patentId === this.patentId) && (value !== this.savedFolderId)) {
                this.savedFolderId = value;
            }
        }
    },
    watch: {
        savedFolderId(val) {
            this.$eventHub.$emit('syncSavedFolderIdInCompare', { patentId: this.patentId, value: val });
        }
    },
    created() {
        this.$eventHub.$on('syncSavedFolderIdInCompare', this.syncSavedFolderIdInCompare);
    },
    beforeDestroy() {
        this.$eventHub.$off('syncSavedFolderIdInCompare', this.syncSavedFolderIdInCompare);
    }
};
